import { Tooltip } from "react-tooltip";
import Button from "shared/components/Button";
import { ReactComponent as MeasureButtonSVG } from "assets/icons/measure.svg";
import { DELAY_SHOW } from "shared/helpers/reactTooltip";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { setMeasureMode } from "features/krpano/details-slice";

interface MeasureButtonProps {}

const MeasureButton: React.FC<MeasureButtonProps> = () => {
  const measureMode = useAppSelector((state) => state.krpano.measureMode);
  const dispatch = useAppDispatch();
  return (
    <div data-tooltip-id="KEY_BUTTON_MEASURE">
      <Button
        colour="Theme"
        additionalClassNames={`PrimaryButton SVGButton ${
          measureMode ? "Active" : ""
        } NoBorder`}
        disabledClass="DisabledOpacity"
        onClick={() => {
          dispatch(setMeasureMode("IN_PROGRESS"));
        }}
        children={
          <MeasureButtonSVG
            height={20}
            width={20}
            role="button"
            aria-label="Measure"
          />
        }
      />
      <Tooltip
        id="KEY_BUTTON_MEASURE"
        place="top"
        className="ToolTip"
        delayShow={DELAY_SHOW}
        children="Measure"
      />
    </div>
  );
};

export default MeasureButton;
